module.exports = __webpack_public_path__ + "img/battery-icon.63c36c28.png";